import { render, staticRenderFns } from "./Ingredient_section.vue?vue&type=template&id=0ee9ba12&scoped=true&"
import script from "./Ingredient_section.vue?vue&type=script&lang=js&"
export * from "./Ingredient_section.vue?vue&type=script&lang=js&"
import style0 from "./Ingredient_section.vue?vue&type=style&index=0&id=0ee9ba12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee9ba12",
  null
  
)

export default component.exports